import generateUuid from '../../utils/generateUuid';
import getFormEventData from '../../utils/getFormEventData';
import setFormSessionId from '../../utils/setFormSessionId';
import injectAudiShiftSource from '../../utils/injectAudiShiftSource';
import injectCAIWalletConfig from '../../utils/injectCAIWalletConfig';

export const DDC_FORM_ONPAGE = 'ddc.form.onPage';

function onPage(win, element) {
	const {
		DDC: {
			dataLayer = {},
			dataLayer: { vehicles, site }
		}
	} = win;

	let eventObject;
	const form = element.closest('form');

	setFormSessionId(form);

	if (form?.offsetParent) {
		if (form.getAttribute(DDC_FORM_ONPAGE) !== 'true') {
			form.setAttribute(DDC_FORM_ONPAGE, 'true');
			const formEventId = generateUuid(form);

			const eventData = {
				element,
				formEventId,
				...getFormEventData({
					form,
					vehicles,
					dataLayer
				})
			};

			if (site?.design?.variationId === 'v9_OEM_AUDI_0005_V1') {
				injectAudiShiftSource(form, eventData);
			}

			eventObject = {
				eventType: DDC_FORM_ONPAGE,
				eventData
			};

			if (Object.keys(eventData.vehicle)) {
				// this is in events/form/submission.js as well
				// just in case the ws-tracking selectors do not find the form for onPage
				injectCAIWalletConfig(win, form);
			}
		}
	}

	return eventObject;
}

export default onPage;
